// Note: The first file of a module here, must also register the module

import "./street-list.component";
import "./streets-view.component";
